import { createLanguageService, LanguageConfig, LanguageService } from '@bigcommerce/checkout-sdk';

import { FALLBACK_LOCALE, FALLBACK_TRANSLATIONS } from './translations';

import B3LanguageService from '../b3checkout/utils/lang'

let languageService: LanguageService | undefined;

export default function getLanguageService(): LanguageService {
    languageService = languageService ?? createLanguageService({
        fallbackLocale: FALLBACK_LOCALE,
        fallbackTranslations: FALLBACK_TRANSLATIONS,
    });
    return languageService;
}

export type InitializeLanguageService = typeof initializeLanguageService;

export function initializeLanguageService(config: LanguageConfig): LanguageService {
    const lang = (window as any).b3themeConfig?.lang
    if (lang && (window as any).B3checkoutLanguageConfig?.locales?.[lang]) {
        const langLocales = B3LanguageService.create()
        Object.keys(config.locales).forEach(item => {config.locales[item] = lang})
        config.locale = lang
        languageService = createLanguageService({
            ...config,
            translations: {"optimized_checkout": langLocales},
            defaultLocale: lang,
            defaultTranslations: {"optimized_checkout": langLocales},
            fallbackLocale: FALLBACK_LOCALE,
            fallbackTranslations: FALLBACK_TRANSLATIONS,
        });
    } else {
        languageService = createLanguageService({
            ...config,
            defaultLocale: config.locale,
            defaultTranslations: config.defaultTranslations,
            fallbackLocale: FALLBACK_LOCALE,
            fallbackTranslations: FALLBACK_TRANSLATIONS,
        });
    }

    return languageService;
}
